export const COMPANY = {
  name: "MadCode",
  owner: "Youssef ARFAOUI",
  status: "Entrepreneur individuel",
  siret: "993 344 258 00013",
  address: "32 Rue Madame, 75006 Paris",
  phone: "06 69 08 38 03",
  email: "contact@madcode.online",
  whatsapp: "https://wa.me/33669083803",
};
